export enum BillingColumns {
  enabled = "enabled",
  license = "license",
  name = "name",
  cost = "cost",
  simTariff = "simTariff",
  simStatus = "simStatus",
  actions = "actions",
}
